export default function CastingSection() {
  return (
    <section id="casting" className="py-32 px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="text-gray-500 text-sm font-medium tracking-wider uppercase mb-4">
            CASTING VISION
          </p>
          <h2 
            className="text-6xl font-black text-gray-900 leading-tight"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            완벽한 캐스팅으로<br />
            <span className="text-gray-400">완성되는 신공의 세계</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mb-6">
              <i className="ri-user-star-line text-3xl text-amber-600"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              윤준호
            </h3>
            
            <p className="text-gray-600 leading-relaxed mb-4">
              강렬함과 섬세함을 동시에 표현할 수 있는 배우. 그의 특유의 아우라는 신공의 고독하고 입체적인 캐릭터를 완벽하게 구현합니다.
            </p>
            
            <div className="pt-4 border-t border-gray-200">
              <span className="text-sm font-semibold text-amber-600">주연 배우 (긍정적 논의 중)</span>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full mb-6">
              <i className="ri-team-line text-3xl text-gray-700"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              검증된 조연진
            </h3>
            
            <p className="text-gray-600 leading-relaxed mb-4">
              충무로 최고의 연기파 배우들과 협의 중입니다. 주인공을 둘러싼 다채로운 캐릭터들이 영화에 깊이를 더할 것입니다.
            </p>
            
            <div className="pt-4 border-t border-gray-200">
              <span className="text-sm font-semibold text-gray-700">조연 및 앙상블</span>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-full mb-6">
              <i className="ri-clapperboard-line text-3xl text-gray-700"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif KR', serif" }}>
              최고의 제작진
            </h3>
            
            <p className="text-gray-600 leading-relaxed mb-4">
              수상 경력의 촬영감독, 음악감독 등 최정상급 스태프로 구성됩니다. 완벽한 비주얼과 사운드를 약속합니다.
            </p>
            
            <div className="pt-4 border-t border-gray-200">
              <span className="text-sm font-semibold text-gray-700">제작진 구성</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
